
// state
const state = {

    // 基本信息
    sid: '',
    title: '',
    cover: '',
    price: 0.0,
    min_discount_price: 0.0,
    max_discount_price: 0.0,
    gift_count: 0.0,

    // 数量
    count: 1,

    // 折扣
    discount_key: 'normal',
    discount_title: '标准折扣',
    discounts: [],

    // 签名/寄语
    word_type_key: 'none',
    word_type_title: '不需要',
    word_types: [],

    // 地址状态
    address_name: '',
    address_mobile: '',
    address_address: '',

    // 教育信息
    edu_type: '',
    edu_name: '',
    edu_job: '',
    edu_school: ''
}

// mutations
const mutations = {
    init(state, data) {
        state.sid = data.sid;
        state.title = data.title;
        state.cover = data.cover;
        state.price = data.price;

        state.min_discount_price = data.min_discount_price;
        state.max_discount_price = data.max_discount_price;
        state.gift_count = data.gift_count;   
        if (data.discounts != null || data.discounts.length > 0) {
            state.discounts = data.discounts;
            state.discount_key = state.discounts[0]["key"];
            state.discount_title = state.discounts[0]["title"];
        }

        if (data.word_types != null || data.word_types.length > 0) {
            state.word_types = data.word_types;
            state.word_type_key = state.word_types[0]["key"];
            state.word_type_title = state.word_types[0]["title"];
        }
    },
    address(state, data) {
        state.address_name = data.name;
        state.address_mobile = data.mobile;
        state.address_address = data.address;
    },
    edu(state, data) {
        state.edu_type = data.type;
        state.edu_name = data.name;
        state.edu_job = data.job;
        state.edu_school = data.school;
    },
    discount(state, data) {
        state.discount_key = data.key;
        state.discount_title = data.title;
    },
    word_type(state, data) {
        state.word_type_key = data.key;
        state.word_type_title = data.title;
    },
    count(state, data) {
        state.count = data; 
    },
}

const getters = {
    order(state) {
        var data = {
            service_id: state.sid,
            title: state.title,
            price: state.price,
            discount_type: state.discount_key,
            discount_value: getters.discount_value(state),

            count: state.count,
            gift_count: state.gift_count,
            amount: getters.discount_total(state),

            name: state.address_name,
            mobile: state.address_mobile,
            address: state.address_address,
        };

        if (state.discount_key == "edu") {
            data.edu_type = state.edu_type;
            data.edu_name = state.edu_name;
            data.edu_job = state.edu_job;
            data.edu_school = state.edu_school;
        }

        if (state.word_types.length > 0) {
            data.word_type = state.word_type_key
        }
        return data;
    },
    errors(state) {
        // 地址不能为空
        // 教育信息不得为空
        // 教育信息名字要和地址一致
        if (!(!!state.address_name && !!state.address_mobile && !!state.address_address)) {
            return '地址不能为空'
        }

        if (state.discount_key == "edu") {
            if (!(!!state.edu_type && !!state.edu_name && !!state.edu_job && !!state.edu_school)) {
                return '教育折扣需要填写教育信息'
            }

            if (state.edu_name != state.address_name) {
                return '收件人需要和教育信息一致'
            }
        }
    },
    address(state) {
        if (state.address_name.length == 0) {
            return ''
        }
        return `${state.address_name}，${state.address_address}`
    },
    edu(state) {
        if (state.edu_name.length == 0) {
            return ''
        }
        return `${state.edu_name}，${state.edu_school}`
    },
    count(state) {
        return state.count
    },
    discount(state) {
        return state.discount_title
    },
    word_type(state) {
        return state.word_type_title
    },
    is_no_word(state) {
        return state.word_types == undefined || state.word_types.length == 0;
    },
    is_edu_discount(state) {
        return state.discount_key == "edu";
    },
    is_none_discount(state) {
        return state.discount_key == "none";
    },
    price(state) {
        return state.price
    },
    // 折扣规则：教育优惠/诸侯都是最高折扣，诸侯-gift_count
    discount_value(state) {
        console.log();
        switch (state.discount_key) {
            case "edu": 
            case "member":
            case "booking":
                return state.max_discount_price; 
            case "none": 
                return 1.0; 
            default: {
                // 标准折扣
                if (state.count >= 10) {
                    return state.max_discount_price;
                } else {
                    return state.min_discount_price;
                }
            }
        }
    },
    discount_price(state) {
        var price = state.price * getters.discount_value(state)
        return price.toFixed(2)
    },
    total(state) {
        var total = state.price * state.count
        return total.toFixed(2)
    },
    discount_total(state) {
        var price = getters.discount_price(state);
        var count = state.count;

        // gift_count由服务器决定，不再局限于会员折扣
        count -= state.gift_count;

        var total = price * count;
        return total.toFixed(2)
    },
    total_save(state) {
        return (getters.total(state) - getters.discount_total(state)).toFixed(2)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    //    actions,
    mutations
}